import { EMPTY_GUID } from 'Utils/constants'

const hasValidId = value =>
  value != null && value !== '' && value !== EMPTY_GUID

const hasValue = value => value != null && value !== ''

const isWarrantyLine = line =>
  Boolean(line?.IsExtendedWarranty || hasValidId(line?.WarrantyProductId))

const sameValue = (first, second) =>
  String(first ?? '').toUpperCase() === String(second ?? '').toUpperCase()

export const matchCartItemsToQuoteLines = (lines = [], cartItems = []) => {
  const availableCartItems = [...cartItems]

  return lines.map(line => {
    const lineIsWarranty = isWarrantyLine(line)
    let cartItemIndex = -1

    if (hasValidId(line?.DocLineId)) {
      cartItemIndex = availableCartItems.findIndex(
        item =>
          hasValidId(item?.DocLineId) &&
          sameValue(item.DocLineId, line.DocLineId)
      )
    }

    if (cartItemIndex < 0 && line?.LineNum != null) {
      cartItemIndex = availableCartItems.findIndex(
        item =>
          item?.LineNum != null &&
          Number(item.LineNum) === Number(line.LineNum) &&
          (!hasValue(item?.ProductId) ||
            !hasValue(line?.ProductId) ||
            sameValue(item.ProductId, line.ProductId)) &&
          isWarrantyLine(item) === lineIsWarranty
      )
    }

    if (cartItemIndex < 0 && hasValue(line?.ProductId)) {
      cartItemIndex = availableCartItems.findIndex(
        item =>
          hasValue(item?.ProductId) &&
          sameValue(item?.ProductId, line?.ProductId) &&
          isWarrantyLine(item) === lineIsWarranty
      )
    }

    if (cartItemIndex < 0) return undefined

    return availableCartItems.splice(cartItemIndex, 1)[0]
  })
}
